import { render } from "./RicercaModello.vue?vue&type=template&id=65e52273"
import script from "./RicercaModello.vue?vue&type=script&lang=js"
export * from "./RicercaModello.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__